<template>
  <div>
    <div
      v-if="Object.keys(dsppartner).length === 0"
      class="d-flex justify-content-center mb-1"
    >
      <b-spinner label="Loading..." />
    </div>
    <div v-else>
      <breadcrumbs
        :breadcrumb-items="breadcrumbItems"
      />
      <b-card>
        <DspPartnerToolbar
          v-if="Object.keys(dsppartner).length !== 0"
          :dsppartner="dsppartner"
          closing
        />
      </b-card>
      <b-form @submit.prevent>
        <validation-observer ref="validationPartnerRules">
          <b-tabs
            pills
          >
            <b-tab active>
              <!-- title -->
              <template #title>
                <feather-icon
                  icon="SettingsIcon"
                  size="18"
                  class="mr-50"
                />
                <span class="font-weight-bold">{{ $t('Settings') }}</span>
              </template>
              <b-card>
                <div class="head-card">
                  <div class="head-card-top">
                    <h4>{{ $t('Main settings') }}</h4>
                    <feather-icon
                      v-b-tooltip.hover.top="$t('Close')"
                      icon="XIcon"
                      size="18"
                      class="toggle-close cursor-pointer"
                      @click="$router.go(-1)"
                    />
                  </div>
                  <hr>
                </div>
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      :label="$t('dsppartners.name')"
                      label-for="i-name"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="name"
                        rules="required"
                      >
                        <b-input-group
                          class="input-group-merge"
                          :class="errors.length == 0 || 'is-invalid'"
                        >
                          <b-input-group-prepend is-text>
                            <feather-icon icon="LayoutIcon" />
                          </b-input-group-prepend>
                          <b-form-input
                            id="i-name"
                            v-model="dsppartner.name"
                            :placeholder="$t('dsppartners.name')"
                            :state="errors.length > 0 ? false:null"
                            autocomplete="name"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group
                      :label="$t('dsppartners.dailymoneylimit')"
                      label-for="i-dailyclicks"
                    >
                      <b-input-group
                        class="input-group-merge"
                      >
                        <b-input-group-prepend is-text>
                          <feather-icon icon="DollarSignIcon" />
                        </b-input-group-prepend>
                        <b-form-input
                          id="i-dailyclicks"
                          v-model="dsppartner.daily_limit"
                          type="number"
                          placeholder="0"
                        />
                      </b-input-group>
                    </b-form-group>
                    <b-form-group
                      :label="$t('dsppartners.maxRequestTime')"
                      label-for="i-max-request-time"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="maxRequestTime"
                        rules="integer|minValue:0|maxValue:20000"
                      >
                        <b-input-group
                          class="input-group-merge"
                          :class="errors.length == 0 || 'is-invalid'"
                        >
                          <b-input-group-prepend is-text>
                            <feather-icon icon="ClockIcon" />
                          </b-input-group-prepend>
                          <b-form-input
                            id="i-max-request-time"
                            v-model.number="dsppartner.timeout"
                            type="number"
                            min="0"
                            max="20000"
                            :placeholder="$t('dsppartners.maxRequestTime')"
                            :state="errors.length > 0 ? false:null"
                          />
                          <b-input-group-append>
                            <b-input-group-text>
                              ms
                            </b-input-group-text>
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group
                      :label="$t('profile.notes')"
                      label-for="i-notes"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="FileTextIcon" />
                        </b-input-group-prepend>
                        <b-form-textarea
                          id="i-notes"
                          v-model="dsppartner.notes"
                          :placeholder="$t('profile.notes')"
                        />
                      </b-input-group>
                    </b-form-group>

                    <b-form-group
                      label="Notification type"
                      label-for="i-notification-type"
                    >
                      <b-form-select
                        v-model="dsppartner.notification_type"
                        :options="notificationTypesLocale"
                      />
                    </b-form-group>

                    <b-form-group
                      :label="$t('sites.status')"
                      label-for="i-status"
                    >
                      <b-form-select
                        v-model="status.value"
                        :options="statusesLocale"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6" />
                </b-row>
                <b-row>
                  <b-col
                    md="12"
                    class="d-flex align-items-center justify-content-end mt-1"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-secondary"
                      class="mr-0 mr-sm-1"
                      :to="{ path: '/dsppartners' }"
                    >
                      <feather-icon
                        icon="ChevronLeftIcon"
                        class="mr-50"
                      />
                      <span class="align-middle">{{ $t('form.back') }}</span>
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      @click="dspPartnerUpdate"
                    >
                      <span class="align-middle">{{ $t('form.save') }}</span>
                      <feather-icon
                        icon="ChevronRightIcon"
                        class="ml-50"
                      />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-tab>
            <!--/ general tab -->
            <b-tab>
              <template #title>
                <feather-icon
                  icon="SettingsIcon"
                  size="18"
                  class="mr-50"
                />
                <span class="font-weight-bold">{{ $t('Subscriptions') }} (Demo)</span>
              </template>
              <b-card>
                <div class="head-card">
                  <div class="head-card-top">
                    <h4>{{ $t('Subscriptions') }} (Demo)</h4>
                    <feather-icon
                      v-b-tooltip.hover.top="$t('Close')"
                      icon="XIcon"
                      size="18"
                      class="toggle-close cursor-pointer"
                      @click="$router.go(-1)"
                    />
                  </div>
                  <hr>
                </div>
                <RtbPartnersControl
                  ref="rtbPartnersControl"
                  :rows="rtbPartners"
                  :existing-subscriptions="existingSubscriptions"
                />
                <b-row>
                  <b-col
                    md="12"
                    class="d-flex align-items-center justify-content-end mt-1"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-secondary"
                      class="mr-0 mr-sm-1"
                      :to="{ path: '/dsppartners' }"
                    >
                      <feather-icon
                        icon="ChevronLeftIcon"
                        class="mr-50"
                      />
                      <span class="align-middle">{{ $t('form.back') }}</span>
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      @click="dspPartnerUpdate"
                    >
                      <span class="align-middle">{{ $t('form.save') }}</span>
                      <feather-icon
                        icon="ChevronRightIcon"
                        class="ml-50"
                      />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-tab>
            <b-tab>
              <template #title>
                <feather-icon
                  icon="KeyIcon"
                  size="18"
                  class="mr-50"
                />
                <span class="font-weight-bold">Api key</span>
              </template>
              <b-card>
                <div class="head-card">
                  <div class="head-card-top">
                    <h4>Api key</h4>
                    <feather-icon
                      v-b-tooltip.hover.top="$t('Close')"
                      icon="XIcon"
                      size="18"
                      class="toggle-close cursor-pointer"
                      @click="$router.go(-1)"
                    />
                  </div>
                  <hr>
                </div>
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      :label="$t('dsppartners.api_key')"
                      label-for="i-api-key"
                    >
                      <b-input-group>
                        <b-form-input
                          id="i-api-key"
                          v-model="dsppartner.api_key"
                          :placeholder="$t('dsppartners.api_key')"
                        />
                        <b-input-group-append>
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            @click="generateApiKey"
                          >
                            <feather-icon
                              icon="RefreshCwIcon"
                              size="16"
                              class="mr-50"
                            />
                            {{ $t('form.generate') }}
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="6" />
                </b-row>
                <template v-if="dsppartner.api_key">
                  <hr class="my-2">
                  <b-row>
                    <b-col md="12">
                      <h5 class="mb-2">
                        API Endpoint
                      </h5>
                      <b-form-group
                        label="Example URL"
                        label-for="i-api-url-example"
                      >
                        <b-input-group>
                          <b-form-input
                            id="i-api-url-example"
                            :value="apiUrlExample"
                            disabled
                            class="font-weight-bold"
                          />
                          <b-input-group-append>
                            <b-button
                              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                              variant="success"
                              size="sm"
                              @click="copyApiUrl"
                            >
                              <feather-icon
                                icon="CopyIcon"
                                size="16"
                                class="mr-50"
                              />
                              {{ $t('form.copy') }}
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <b-card
                        bg-variant="light"
                        class="mb-0"
                      >
                        <h6 class="mb-2">
                          <feather-icon
                            icon="InfoIcon"
                            size="18"
                            class="mr-50"
                          />
                          API Documentation
                        </h6>
                        <div class="mb-2">
                          <strong>Base URL:</strong>
                          <code class="ml-1">https://api.phoenix-widget.com/api/client/dsp/{partner_id}</code>
                        </div>
                        <div class="mb-2">
                          <strong>Query Parameters:</strong>
                          <ul class="mb-0 mt-1">
                            <li><code>token</code> <span class="badge badge-danger">required</span> - API key</li>
                            <li><code>from</code> <span class="badge badge-warning">required*</span> - Start date (YYYY-MM-DD)</li>
                            <li><code>to</code> <span class="badge badge-warning">required*</span> - End date (YYYY-MM-DD)</li>
                            <li><code>limit</code> <span class="badge badge-secondary">optional</span> - Items per page (for pagination)</li>
                            <li><code>page</code> <span class="badge badge-secondary">optional</span> - Page number (for pagination)</li>
                          </ul>
                          <small class="text-muted">* At least one of <code>from</code> or <code>to</code> is required</small>
                        </div>
                      </b-card>
                    </b-col>
                  </b-row>
                </template>
                <b-row>
                  <b-col
                    md="12"
                    class="d-flex align-items-center justify-content-end mt-1"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-secondary"
                      class="mr-0 mr-sm-1"
                      :to="{ path: '/dsppartners' }"
                    >
                      <feather-icon
                        icon="ChevronLeftIcon"
                        class="mr-50"
                      />
                      <span class="align-middle">{{ $t('form.back') }}</span>
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      @click="dspPartnerUpdate"
                    >
                      <span class="align-middle">{{ $t('form.save') }}</span>
                      <feather-icon
                        icon="ChevronRightIcon"
                        class="ml-50"
                      />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-tab>
          </b-tabs>
        </validation-observer>
      </b-form>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import useJwt from '@/auth/jwt/useJwt'
import options from '@/libs/options'

import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BCard,
  BForm,
  BFormGroup,
  BInputGroupAppend,
  BInputGroupText,
  BInputGroupPrepend,
  BInputGroup,
  BFormInput,
  BSpinner,
  VBTooltip,
  BFormSelect,
  BButton,
  BFormTextarea,
} from 'bootstrap-vue'
import {
  ValidationProvider,
  ValidationObserver,
  extend,
} from 'vee-validate'
import {
  required,
  integer,
  min,
} from '@validations'
import Breadcrumbs from '@/views/ui/breadcrumbs/Breadcrumbs.vue'
import Ripple from 'vue-ripple-directive'

import RtbPartnersControl from '@/views/dashboard/dsppartners/RtbPartnersControl.vue'
import DspPartnerToolbar from './DspPartnerToolbar.vue'

extend('minValue', value => value >= 0 || 'Значение должно быть не меньше 0')
extend('maxValue', (value, [max]) => value <= max || `Значение должно быть не больше ${max}`)

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    BCard,
    Breadcrumbs,
    BForm,
    BFormGroup,
    BInputGroupAppend,
    BInputGroupText,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
    BButton,
    BFormTextarea,
    DspPartnerToolbar,
    RtbPartnersControl,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      pageTitle: '',
      min,
      required,
      integer,
      dsppartner: {},
      breadcrumbItems: [],
      status: {},
      notificationTypes: [
        { value: 'burl', text: 'Burl' },
        { value: 'nurl', text: 'Nurl' },
      ],
      ...options,
      rtbPartners: [],
      existingSubscriptions: [],
    }
  },
  computed: {
    statusesLocale() {
      return this.statuses.map(s => {
        const item = {}
        item.value = s.value
        item.text = this.$t(`selects.statuses.${s.value}`)
        return item
      })
    },
    notificationTypesLocale() {
      return this.notificationTypes.map(s => {
        const item = {}
        item.value = s.value
        item.text = this.$t(`selects.notification_types.${s.value}`)
        return item
      })
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        negative     : 'outline-primary',
        active       : 'outline-success',
        inactive     : 'outline-danger',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    apiUrlExample() {
      const today = new Date()
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
      const formatDate = date => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }
      const fromDate = formatDate(firstDayOfMonth)
      const toDate = formatDate(today)

      const partnerId = this.dsppartner._id || this.$route.params.id || '{partner_id}'
      const apiKey = this.dsppartner.api_key || '{api_key}'

      return `https://api.phoenix-widget.com/api/client/dsp/${partnerId}?from=${fromDate}&to=${toDate}&token=${apiKey}`
    },
  },
  created() {
    this.getDspPartnerData()
    this.fethPartners()
  },
  methods: {
    async getDspPartnerData() {
      const responseData = await useJwt.getDsppartner(this.$route.params.id)
      this.dsppartner = responseData.data.dsppartner || {}
      this.dsppartner.timeout = this.dsppartner.timeout || 1000
      this.dsppartner.notification_type = this.dsppartner.notification_type || 'burl'
      if (!('api_key' in this.dsppartner)) {
        this.$set(this.dsppartner, 'api_key', '')
      } else {
        this.dsppartner.api_key = this.dsppartner.api_key || ''
      }
      this.existingSubscriptions = this.dsppartner.subscriptions || []
      this.breadcrumbItems = [
        {
          text: this.$t('DSP partners'),
          to: '/dsppartners/',
        },
        {
          text: this.dsppartner.name,
          to: `/dsppartners/${this.dsppartner._id}/`,
        },
        {
          text: this.$t('Settings'),
          active: true,
        },
      ]
      if (this.dsppartner.status !== '') {
        const statusText = this.dsppartner.status.charAt(0).toUpperCase() + this.dsppartner.status.slice(1)
        this.status = { value: this.dsppartner.status, text: statusText }
      }
    },
    dspPartnerUpdate() {
      this.$refs.validationPartnerRules.validate().then(success => {
        if (success) {
          this.dsppartner.status = this.status.value

          // Получаем данные подписок из RtbPartnersControl
          if (this.$refs.rtbPartnersControl) {
            this.dsppartner.subscriptions = this.$refs.rtbPartnersControl.getSubscriptionsData()
          }

          useJwt.setDsppartner(this.$route.params.id, { dsppartner: this.dsppartner })
            .then(() => {
              this.$store.dispatch('error-store/showNotify', {
                title: 'Partner saved',
                msg: 'Partner has been saved successfully',
                variant: 'success',
              },
              { root: true })
            })
            .catch(error => {
              if (error.response && error.response.status === 422) {
                if (error.response.data.errors.length) {
                  error.response.data.errors.forEach(err => {
                    const field = err.source.pointer.split('/')
                    this.$store.dispatch(
                      'error-store/showNotify',
                      {
                        title: `Error [${field[field.length - 1]}]`,
                        msg: err.detail,
                        variant: 'danger',
                      },
                      { root: true },
                    )
                  })
                }
              }
              if (error.response && (error.response.status === 500 || error.response.status === 400)) {
                this.$store.dispatch(
                  'error-store/showNotify',
                  {
                    title: error.response.statusText,
                    msg: error.message,
                    variant: 'danger',
                  },
                  { root: true },
                )
              }
            })
        }
      })
    },
    async fethPartners() {
      this.rtbPartners = []
      const responseData = await useJwt.partners()
      this.rtbPartners = responseData.data.partners || []
    },
    generateApiKey() {
      const newKey = uuidv4()
      this.$set(this.dsppartner, 'api_key', newKey)
    },
    async copyApiUrl() {
      try {
        await navigator.clipboard.writeText(this.apiUrlExample)
        this.$store.dispatch('error-store/showNotify', {
          title: 'Copied',
          msg: 'API URL copied to clipboard',
          variant: 'success',
        },
        { root: true })
      } catch (error) {
        this.$store.dispatch('error-store/showNotify', {
          title: 'Error',
          msg: 'Failed to copy to clipboard',
          variant: 'danger',
        },
        { root: true })
      }
    },
  },
}
</script>
